import { Box, TextField } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';

function FiltroRangoFecha({ arrayDataToFilter = [], onResultsCallback, compareDatePropName = 'updated_at' }) {
  const [fechaDesde, setFechaDesde] = useState('');
  const [fechaHasta, setFechaHasta] = useState('');

  console.log(fechaDesde, fechaHasta);

  const filterDate = useCallback(
    (dataArr, initialDate, finalDate) => {
      const filteredData = dataArr.filter((item) => {
        // console.log(item);
        if (initialDate === '' && finalDate === '') {
          return item;
        }

        if (typeof item[compareDatePropName] === 'object') {
          if (
            item[compareDatePropName]?.toDate() >= (initialDate ? new Date(initialDate) : new Date('2017-05-24')) &&
            item[compareDatePropName]?.toDate() <= (finalDate ? new Date(finalDate) : new Date())
          ) {
            return item;
          }
        }
        return false;
      });

      return filteredData;
    },
    [compareDatePropName]
  );

  useEffect(() => {
    const results = filterDate(arrayDataToFilter, fechaDesde, fechaHasta);
    onResultsCallback(results);
  }, [arrayDataToFilter, fechaDesde, fechaHasta, filterDate, onResultsCallback]);

  return (
    <Box sx={{ display: 'flex', gap: '10px' }}>
      <TextField
        type="date"
        label="Desde"
        onChange={(e) => setFechaDesde(e.target.value)}
        InputLabelProps={{
          shrink: true
        }}
      />

      <TextField
        type="date"
        label="Hasta"
        onChange={(e) => setFechaHasta(e.target.value)}
        InputLabelProps={{
          shrink: true
        }}
      />
    </Box>
  );
}

export default FiltroRangoFecha;
